import { ExpressionConfiguration } from "../../../../Expressions/ExpressionConfiguration";
import { IConfigStorage } from "../../../../Common/IConfigStorage";
import { ValidationIssue } from "../../../../Common/IDesignValidationProvider";

export class RuleTableCell implements IConfigStorage {
    _columnId: string;
    expression?: ExpressionConfiguration;

    constructor(colId: string) {
        this._columnId = colId;
    }

    getStorageData(): object {
        let obj = {};
        Reflect.set(obj, "_columnId", this._columnId);
        Reflect.set(obj, "expression", this.expression?.getStorageData());

        return obj;
    }

    setStorageData(data: object): void {
        this._columnId = Reflect.get(data, "_columnId");

        let expressionData = Reflect.get(data, "expression");
        if (expressionData) {
            this.expression = new ExpressionConfiguration();
            this.expression.setStorageData(expressionData);
        } else {
            this.expression = undefined;
        }
    }

    getDesignValidationIssues(): ValidationIssue[] {
        let issues: ValidationIssue[] = [];

        if (this.expression) {
            issues.push(...this.expression.getDesignValidationIssues());
        } else {
            issues.push(new ValidationIssue("Expression is required"));
        }

        return issues;
    }
}
